import baseApi from "../api/baseApi";

const nameChangeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    createNameChangeRequest: builder.mutation({
      query: ({ firstName, lastName, reasonForCorrection }) => ({
        url: "/namechange/createNameChangeRequest",
        method: "POST",
        body: { firstName, lastName, reasonForCorrection },
      }),
    }),
  }),
});

export const { useCreateNameChangeRequestMutation } = nameChangeApi;

export default nameChangeApi;
